import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContext";

// Forzar formato 24H en todos los inputs de tipo time
// Esta función se ejecuta cuando el DOM está listo y cada vez que se agregan nuevos inputs
const force24HourFormat = () => {
  const timeInputs = document.querySelectorAll('input[type="time"]');
  timeInputs.forEach(input => {
    // Agregar atributos para forzar formato 24H
    input.setAttribute('lang', 'en-GB');
    input.setAttribute('step', '60');
    
    // Listener para validar el valor ingresado
    input.addEventListener('input', (e) => {
      const value = e.target.value;
      if (value) {
        const [hours, minutes] = value.split(':').map(Number);
        // Si las horas son mayores a 23, ajustar a formato válido
        if (hours > 23) {
          e.target.value = `${String(hours % 24).padStart(2, '0')}:${String(minutes || 0).padStart(2, '0')}`;
        }
      }
    }, { passive: true });
  });
};

// Ejecutar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', force24HourFormat);

// Observar cambios en el DOM para aplicar a inputs dinámicos
const observer = new MutationObserver(() => {
  force24HourFormat();
});

// Iniciar observador cuando el documento esté listo
if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Ignorar error benigno de ResizeObserver (común con gráficos de Material-UI)
// Este error es conocido y no afecta la funcionalidad de la aplicación
const resizeObserverErrorHandler = (e) => {
  if (
    e.message?.includes('ResizeObserver') ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    return false;
  }
};

window.addEventListener('error', resizeObserverErrorHandler, true);

// También manejar errores no capturados
const originalErrorHandler = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (
    typeof message === 'string' &&
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return true; // Suprimir el error
  }
  if (originalErrorHandler) {
    return originalErrorHandler.call(this, message, source, lineno, colno, error);
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);